import { render, staticRenderFns } from "./CertificationItem.vue?vue&type=template&id=d567252c&"
import script from "./CertificationItem.vue?vue&type=script&lang=js&"
export * from "./CertificationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports